import { ICellRendererParams } from 'ag-grid-community';
import { ISwapQualityIssueForList } from '@nkr/models/index';
import { SwapQualityIssueListType, SwapQualityIssueReportedBy } from '@nkr/enums/index';
import { SwapQualityIssueAction } from './swap-quality-issue-action';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';

const menuItemList = [
    { action: SwapQualityIssueAction.Record, title: 'Record Swap Quality Issue' },
    { action: SwapQualityIssueAction.NoIssue, title: 'No Issues to Report' },
    { action: SwapQualityIssueAction.View, title: 'View Swap Quality Issue' },
    { action: SwapQualityIssueAction.Reopen, title: 'Reopen Quality Issue' },
    { action: -1, title: '' }
];

interface IProps extends ICellRendererParams {
    centerId: number,
    listType: SwapQualityIssueListType,
    reportedBy: SwapQualityIssueReportedBy,
    isAdmin: boolean,
    isAdminLogin: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: SwapQualityIssueAction) => void
}

const ActionButtonRenderer = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(id, action);
    };

    const getUrl = (action: SwapQualityIssueAction, id: number) => {
        let hrefPrefix = props.isAdmin ? '/admin/swap-quality-issue' : `/center/${props.centerId}/action-center/swap-quality-issue`;

        switch (action) {
            case SwapQualityIssueAction.Record: return `${hrefPrefix}/edit?id=${id}&previous=${props.listType}&reportedBy=${props.reportedBy}`;
            case SwapQualityIssueAction.NoIssue: return `${hrefPrefix}/no-issue?id=${id}&previous=${props.listType}&reportedBy=${props.reportedBy}`;
            case SwapQualityIssueAction.View: return `${hrefPrefix}/view?id=${id}&previous=${props.listType}&reportedBy=${props.reportedBy}`;
        }

        return null;
    };

    const getMenuItems = () => {
        let data = props.data as ISwapQualityIssueForList;

        let menuItems = [];

        if (data.isFinalized == false) {
            menuItems.push(SwapQualityIssueAction.Record);

            if (data.isLatePickup == false) {
                menuItems.push(SwapQualityIssueAction.NoIssue);
            }
        }

        if (data.isFinalized) {
            menuItems.push(SwapQualityIssueAction.View);
        }

        if (data.isFinalized && (props.isAdmin || props.isAdminLogin)) {
            menuItems.push(SwapQualityIssueAction.Reopen);
        }

        return menuItems;
    };

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.id) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a> };
        }
    });

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={handleMenuToggle}
                onSelect={handleMenuSelection}
            />
        </div>
    );
}

export default ActionButtonRenderer;